/* Buffelh product behaviour: the ladder buy box, flavour chips, quantity select, gallery and the phone sticky bar.
   Works on every element marked data-bx-buy (product page and home ladder band). The server prints a complete,
   correctly priced default state, so the page is readable before this script runs. */
(function () {
  'use strict';
  if (window.__bxProductReady) return;
  window.__bxProductReady = true;

  function init(buy) {
    var dataEl = buy.querySelector('[data-bx-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var scope = buy.closest('[data-bx-pdp]') || buy;
    var form = buy.closest('form');
    var $ = function (s, r) { return (r || buy).querySelector(s); };
    var amt = $('[data-bx-amt]'), amtLab = $('[data-bx-amtlab]'), per = $('[data-bx-per]'), fd = $('[data-bx-fd]');
    var idIn = $('[data-bx-id]'), qIn = $('[data-bx-quantity]');
    var cta = $('[data-bx-cta]');
    var packs = [].slice.call(buy.querySelectorAll('input[data-bx-pack]'));
    var more = $('[data-bx-more]');
    var flavs = [].slice.call(buy.querySelectorAll('input[data-bx-flavour]'));
    var qsel = $('[data-bx-qty]');
    var bar = scope.querySelector('.bx-sbar');
    var barLabel = scope.querySelector('[data-bx-bar-label]');
    var barPrice = scope.querySelector('[data-bx-bar-price]');
    var barFree = scope.querySelector('[data-bx-bar-free]');
    var barCta = scope.querySelector('[data-bx-bar-cta]');
    var slides = [].slice.call(scope.querySelectorAll('[data-bx-gallery] [data-bx-slide]'));
    var thumbs = [].slice.call(scope.querySelectorAll('[data-bx-thumb]'));
    var tmpl = cta ? (cta.getAttribute('data-label') || 'Add to cart') : 'Add to cart';
    var soldTxt = cta ? (cta.getAttribute('data-soldout') || 'Sold out') : 'Sold out';

    var state = { pack: '', flavour: '', qty: 1 };
    packs.forEach(function (p) { if (p.checked || p.selected) state.pack = p.value; });
    if (more && more.value) state.pack = more.value;
    flavs.forEach(function (f) { if (f.checked) state.flavour = f.value; });

    function rowFor(pack) { for (var i = 0; i < data.rows.length; i++) if (data.rows[i].pack === pack) return data.rows[i]; return null; }
    function variantFor(pack, flav) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (v.pack === pack && (!flav || v.flavour === flav)) return v;
      }
      return null;
    }
    function showSlide(i) {
      slides.forEach(function (s, n) { s.hidden = n !== i; });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
    }
    function showMedia(id) {
      if (!slides.length) return;
      if (!id) { showSlide(0); return; }
      for (var i = 0; i < slides.length; i++) {
        if ((slides[i].getAttribute('data-media') || '').split(' ').indexOf(String(id)) > -1) { showSlide(i); return; }
      }
      showSlide(0);
    }
    function setCta(label, off) {
      [cta, barCta].forEach(function (b) {
        if (!b) return;
        b.textContent = off ? soldTxt : label;
        b.disabled = !!off;
      });
    }

    function render() {
      var label = '', price = '', perT = '', free = false, off = false, vid = null, media = null;
      if (data.mode === 'ladder') {
        var r = rowFor(state.pack), v = variantFor(state.pack, state.flavour);
        if (!r || !v) return;
        label = r.label; price = r.price; perT = r.per; free = r.free; off = !v.available; vid = v.id; media = v.media;
        packs.forEach(function (p) {
          var lab = p.closest('.bx-step');
          if (!lab) return;
          var pv = variantFor(p.value, state.flavour);
          var gone = pv && !pv.available;
          p.disabled = !!gone;
          lab.classList.toggle('bx-out', !!gone);
          lab.classList.toggle('bx-sel', p.checked && p.value === state.pack);
          var pk = lab.querySelector('[data-bx-pick]');
          if (pk) pk.textContent = gone ? soldTxt : (lab.classList.contains('bx-sel') ? 'Selected' : 'Select');
        });
        if (idIn && vid) idIn.value = vid;
      } else if (qsel) {
        var o = qsel.options[qsel.selectedIndex];
        label = o.getAttribute('data-label'); price = o.getAttribute('data-price'); perT = o.getAttribute('data-per') || '';
        free = o.getAttribute('data-free') === 'true';
        state.qty = parseInt(o.value, 10) || 1;
        if (qIn) qIn.value = state.qty;
        var sv = null;
        for (var i = 0; i < data.variants.length; i++) { sv = data.variants[i]; break; }
        off = sv ? !sv.available : false;
      }
      if (amt) amt.textContent = price;
      if (amtLab) amtLab.textContent = label ? label + ':' : '';
      if (per) per.textContent = perT;
      if (fd) fd.textContent = free ? data.freeOn : data.freeOff;
      var fl = state.flavour ? state.flavour + ', ' : '';
      if (barLabel) barLabel.textContent = fl + label;
      if (barPrice) barPrice.textContent = price;
      if (barFree) barFree.textContent = free ? 'Free delivery' : (data.feeBar || 'Delivery at checkout');
      var text = tmpl.indexOf('[pack]') > -1 ? tmpl.replace('[pack]', label) : tmpl;
      setCta(text, off);
      flavs.forEach(function (f) { f.closest('label').classList.toggle('bx-sel', f.checked); });
      return media;
    }

    packs.forEach(function (p) {
      if (p.tagName !== 'INPUT') return;
      p.addEventListener('change', function () {
        state.pack = p.value;
        if (more) more.selectedIndex = 0;
        render();
      });
    });
    if (more) more.addEventListener('change', function () {
      if (!more.value) return;
      state.pack = more.value;
      packs.forEach(function (p) { if (p.tagName === 'INPUT') p.checked = false; });
      var steps = buy.querySelectorAll('.bx-step');
      steps.forEach(function (s) { s.classList.remove('bx-sel'); var pk = s.querySelector('[data-bx-pick]'); if (pk && !s.classList.contains('bx-out')) pk.textContent = 'Select'; });
      render();
    });
    flavs.forEach(function (f) {
      f.addEventListener('change', function () {
        state.flavour = f.value;
        var m = render();
        if (m !== null && m !== undefined) showMedia(m);
        else showMedia(f.getAttribute('data-media'));
      });
    });
    if (qsel) qsel.addEventListener('change', render);
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { showSlide(n); }); });
    if (barCta && form) barCta.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });

    /* ?qty=N (from the home page options or a link): choose the pack with N units, or N in the quantity select.
       ?variant= is handled by the server, which prints that pack as already selected. */
    (function () {
      var q = null, hasVariant = false;
      try { var u = new URLSearchParams(window.location.search); q = parseInt(u.get('qty'), 10); hasVariant = !!u.get('variant'); } catch (e) {}
      if (!q || hasVariant || !scope.hasAttribute('data-bx-pdp')) return;
      if (data.mode === 'ladder') {
        for (var i = 0; i < data.rows.length; i++) {
          if (data.rows[i].n === q) {
            state.pack = data.rows[i].pack;
            packs.forEach(function (p) { if (p.tagName === 'INPUT') p.checked = (p.value === state.pack); });
            if (more) { more.value = ''; for (var k = 0; k < more.options.length; k++) if (more.options[k].value === state.pack) more.selectedIndex = k; }
            break;
          }
        }
      } else if (qsel) {
        for (var j = 0; j < qsel.options.length; j++) if (parseInt(qsel.options[j].value, 10) === q) qsel.selectedIndex = j;
      }
    })();

    render();
    if (flavs.length) {
      var cur = flavs.filter(function (f) { return f.checked; })[0];
      if (cur && cur.getAttribute('data-media')) showMedia(cur.getAttribute('data-media'));
    }
    if (bar && cta && 'IntersectionObserver' in window) {
      document.body.classList.add('bx-hasbar');
      /* 27 Oct: show the bar (price + Add to cart) whenever the main button is off screen, above or below,
         so a phone sees the price and a buy button on the first screen. Phones only: the bar is display:none on desktop. */
      new IntersectionObserver(function (e) {
        bar.classList.toggle('bx-show', !e[0].isIntersecting);
      }).observe(cta);
    }
  }

  document.querySelectorAll('[data-bx-buy]').forEach(init);
})();
